import { Outlet, useLocation } from "react-router-dom";
import Contact from "../home/Contact";
import Partners from "../home/Partners";
import MFooter from "./footer/MFooter";
import AHeader from "./header/AHeader";
import AMHeader from "./header/AMHeader";
import MHeader from "./header/MHeader";
import MobileQuick from "./quick/MobileQuick";
import QuickBar from "./quick/QuickBar";
import RightQuick from "./quick/RightQuick";

const Layout = () => {
  const { pathname } = useLocation();

  if (pathname.includes("login")) {
    return (
      <div className="relative w-full h-full max-w-[100vw] overflow-x-hidden">
        <Outlet />
      </div>
    );
  }
  if (pathname.includes("admin")) {
    if (!sessionStorage.getItem("email")) {
      window.location.href = "/admin/login";
      return <></>;
    }
    return (
      <div className="relative w-full h-full max-w-[100vw] overflow-x-hidden">
        <AMHeader />
        <AHeader />
        <div className="relative w-full h-full max-w-screen-2xl py-32 lg:py-36 px-2 lg:pl-[280px] 2xl:pl-[300px]">
          <Outlet />
        </div>
      </div>
    );
  }

  if (pathname.includes("about") || pathname.includes("products")) {
    return (
      <div className="relative w-full h-full max-w-[100vw]">
        <MHeader />
        <div className="relative w-full h-full mt-20 lg:mt-24 xl:mt-32 min-h-[50vh] transition-all duration-100">
          <Outlet />
          <Contact />
          <Partners />
          <QuickBar />
          <RightQuick />
          <MFooter />
          <MobileQuick />
        </div>
      </div>
    );
  }

  return (
    <div className="relative w-full h-full max-w-[100vw]">
      <MHeader />
      <div className="relative w-full h-fit mt-20 lg:mt-24 xl:mt-32 min-h-[50vh] transition-all duration-100 ">
        <Outlet />
      </div>
      <QuickBar />
      <RightQuick />
      <MFooter />
      <MobileQuick />
    </div>
  );
};

export default Layout;
